import * as React from "react"
import AboveFold from "../components/abovefold"
import Navbar from "../components/navbar"
import Footer from "../components/footer"
import Why from "../components/why"
import Sobre from "../components/sections/sobre"
import Produtos from "../components/sections/produtos"
import Amare from "../components/sections/amare"
import { HOME_ID, landOnHash } from "../components/scroll"

/*
 * The whole site, minus Contato.
 *
 * Sobre, Produtos and Amaré are sections of this page rather than routes of
 * their own — the navbar scrolls between them. Each still has a route as well
 * (/about/, /product/, /amare/) rendering the same component, so links that
 * were shared before the site was merged still land somewhere sensible.
 *
 * Contato is deliberately left out: it is a form, and it stays a page.
 */
export default function Home() {
  /* Arriving at /#produtos — from Contato, or from a shared link — needs the
     browser's hash jump repeating, since nothing is in the document when it
     first runs. See components/scroll.js. */
  React.useEffect(landOnHash, [])

  return (
    <React.Fragment>
      <Navbar />
      <div id={HOME_ID}>
        <AboveFold headerText="Feito no Ceará."></AboveFold>
        <Why></Why>
      </div>
      <Sobre />
      <Produtos />
      <Amare />
      <Footer />
    </React.Fragment>
  )
}
